
import { 
    FaDollarSign, 
    FaHashtag,  
    FaUser, 
    FaUserTag, 
    AppEnum,
    Header, 
    FaBuilding,
    OptionHelper,
    PropertyEnums,
    RecordMap
} from "@/Shared";

import { CityModel, SectorModel } from '@/Domains';

import { PropertyViewModel } from "../Logic";

export class PropertyHeader {

    private constructor() { }

    get id() {
        return {
            key: 'id',
            icon: <FaHashtag />,
            label: 'ID',
            type: 'number',
            isSortable: true
        }
    }

    getOperationType(oprationTypes: AppEnum[]) {
        return {
            key: 'operationType',
            icon: <FaUserTag />,
            label: 'Type d\'opération',
            type: 'string',
            isSortable: true,
            filter: {
                label: "Opération",
                options: oprationTypes,
                case: 'sensitive'
            }
        }
    }

    getType(types: AppEnum[]) {
        return {
            key: 'propertyType',
            icon: <FaUserTag />,
            label: 'Type de bien',
            type: 'string',
            isSortable: true,
            filter: {
                label: "Type",
                options: types,
                case: 'sensitive'
            }
        }
    }

    getCategory(categoryTypes: AppEnum[]) {
        return {
            key: 'propertyCategory',
            icon: <FaUserTag />,
            label: 'Catégorie de bien',
            type: 'string',
            isSortable: true,
            isHidden: true,
            filter: {
                label: "Catégorie",
                options: categoryTypes,
                case: 'sensitive'
            }
        }
    }


    get furnished() {
        return {
            key: 'furnished',
            icon: <FaUser />,
            label: 'Meublé',
            type: 'string',
            isSortable: true
        }
    }

    getSector(sectorMap: RecordMap<SectorModel>) {
        return {
            key: 'sector',
            icon: <FaBuilding />,
            label: 'Secteur',
            type: 'number',
            isSortable: true,
            filter: {
                label: "Localisation",
                options: OptionHelper.sectorOptions(sectorMap.toArray()),
                case: 'sensitive'
            }
        }
    }

    getCity(cityMap: RecordMap<CityModel>) {

        return {
            key: 'city',
            icon: <FaUserTag />,
            label: 'Ville',
            type: 'number',
            isSortable: true,
            filter: {
                label: "Ville",
                options: OptionHelper.cityOptions(cityMap.toArray()),
                case: 'sensitive'
            }
        }
    }

    getAvailability(availabilityMap: AppEnum[]) {
        return {
            key: 'availability',
            icon: <FaUserTag />,
            label: 'Disponibilité',
            type: 'string',
            isSortable: true,
            filter: {
                label: "Disponibilité",
                options: availabilityMap,
                case: 'sensitive'
            }
        }
    }

    get availableAt() {
        return {
            key: 'availableAt',
            icon: <FaUser />,
            label: 'Date Disponible',
            type: 'string',
            isSortable: true
        }
    }

    get price() {
        return {
            key: 'price',
            icon: <FaDollarSign />,
            label: 'Prix',
            type: 'number',
            isSortable: true
        }
    }

    static build(
        sectorMap: RecordMap<SectorModel>,
        cityMap: RecordMap<CityModel>,
        viewEnums : PropertyEnums

    ): Record<keyof PropertyViewModel, Header<PropertyViewModel>> {

        const header = new PropertyHeader();

        return {
            id: header.id,
            operationType: header.getOperationType(viewEnums.OperationTypeEnum),
            propertyCategory: header.getCategory(viewEnums.PropertyCategoryEnum),
            propertyType: header.getType(viewEnums.PropertyTypeEnum),
            furnished: header.furnished,
            sector: header.getSector(sectorMap),
            city: header.getCity(cityMap),
            availability: header.getAvailability(viewEnums.AvailabilityEnum),
            availableAt: header.availableAt,
            price: header.price
        } as Record<keyof PropertyViewModel, Header<PropertyViewModel>>
    }
}


